function AppFooterCopyright() {
  return (
    <div className="font-general-regular flex justify-center items-center text-center">
      <div className="text-sm sm:text-base text-slate-700 dark:text-slate-300">
        &copy; {new Date().getFullYear()} All rights reserved.
        <a
          href="https://github.com/kangzy-fix"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:underline hover:text-teal-700 dark:hover:text-teal-300 ml-1.5 font-general-medium"
        >
          Ian Kangacha
        </a>
      </div>
    </div>
  );
}

export default AppFooterCopyright;
